import "../tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most tools just pass the component context to their templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated by tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext and update. update is
 *  - identical to render by default, but you can override it. the update lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context value, you update your view there.
 */

(function (Component) {
  "use strict";

  Sparkle.PageBuilder.Tool({
    name: "checkbox",

    templateId: "checkbox-template",
    $checkbox: null,

    setDefault: function () {
      if (this.component.context == null) {
        var expanded = Component.expandAttribute(this.config);
        if (expanded !== undefined) {
          this.component.save(expanded);
        }
      }
    },

    update: function () {
      this.$checkbox[0].checked = this.component.context;
    },

    bind: function () {
      var me = this;
      this.$checkbox = jQuery(this.element).find("input");
      this.$checkbox.on("change", function () {
        me.component.save(this.checked);
        me.component.render();
      });
    },

    /**
     * @name bind
     * @description
     * Unbind the different event listeners to the component added during the
     *  initial bind step.
     * @param {HTMLElement} element
     */
    unbind: function (element) {
      this.$checkbox.off("change");
    },
  });
})(Sparkle.PageBuilder.Component);
